(() => {
  if (customElements.get('vm-premium-reserve')) return;
  customElements.define('vm-premium-reserve', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const link = this.querySelector('.vm-reserve__send');
      const variants = JSON.parse(this.querySelector('[data-reservation-variants]').textContent);
      const info = this.closest('product-info');
      const selected = () => {
        const id = info?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
        return variants.find(v => String(v.id) === id);
      };
      const update = () => {
        const variant = selected();
        const available = Boolean(variant?.available);
        const name = form.elements.reservation_name.value.trim();
        const phone = form.elements.reservation_phone.value.trim();
        const valid = name && phone && form.checkValidity();
        link.setAttribute('aria-disabled', String(!available || !valid));
        this.querySelector('.vm-reserve__unavailable').hidden = available;
        if (!available || !valid) { link.removeAttribute('href'); return; }
        const url = new URL(this.dataset.url);
        url.searchParams.set('variant', variant.id);
        const message = [
          'Hi Vi Mobile, I would like to reserve this device.',
          '',
          '*Device*',
          'Product: ' + this.dataset.title,
          'Selected option: ' + variant.title,
          'Product link:',
          url.href,
          '',
          '*Customer details*',
          'Name: ' + name,
          'Mobile number: ' + phone,
          '',
          '*Reservation*',
          'Deposit: S$20',
          'Hold period: 5 days',
          '',
          '*PayNow*',
          'UEN: 201836556G',
          'Recipient: VMCS PTE LTD',
          'Amount: S$20',
          'PayNow QR:',
          new URL(this.dataset.qrUrl, window.location.origin).href,
          '',
          'Please confirm availability before I pay.',
          'I will send my payment screenshot after payment.',
          '',
          '*Reservation T&C*',
          'I agree to the following:',
          'The 5-day reservation starts when Vi Mobile confirms receipt of my deposit.',
          'If I do not collect within 5 days, my S$20 deposit will be forfeited and will not be refunded.'
        ].join('\n');
        link.href = 'https://wa.me/' + this.dataset.phone + '?text=' + encodeURIComponent(message);
      };
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      form.addEventListener('submit', event => { event.preventDefault(); update(); form.reportValidity(); });
      link.addEventListener('click', event => {
        update();
        if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); form.reportValidity(); }
      });
      this.observer = new MutationObserver(update);
      if (info) this.observer.observe(info, {subtree:true,childList:true,attributes:true,attributeFilter:['value','class']});
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
